import * as React from "react";
import {LoaderSpinner} from "./LoaderSpinner";
import '../../../css/teams-channel-selector.css';
import {Promise} from "es6-promise";

interface TeamsChannelSelectorProps {
    name: string,
    label: string,
    value: string,
}

interface TeamsChannelSelectorState {
    joinedTeams: Team[],
    teamChannels: Channel[],
    showLoader: boolean,
    activeTeam: Team,
    activeChannel: Channel,
    value: string,
}

interface Team {
    id: string,
    properties: {
        displayName: string,
    }
}

interface Channel {
    id: string,
    properties: {
        displayName: string,
    }
}

/**
 * Text Input Element
 */
export class TeamsChannelSelector extends React.Component<TeamsChannelSelectorProps, TeamsChannelSelectorState> {

    public static defaultProps = {};

    apiHeaders: any;

    state: TeamsChannelSelectorState;

    constructor(props: any) {
        super(props);

        this.apiHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        this.state = {
            joinedTeams: [],
            teamChannels: [],
            showLoader: true,
            activeTeam: null,
            activeChannel: null,
            value: this.props.value,
        };

    }

    componentDidMount(): void {
        this.updateJoinedTeams();
    }

    updateJoinedTeams() {
        fetch('/wp-json/erl-api/v1/teams/get-joined-teams', {
            method: 'GET',
            headers: this.apiHeaders,
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({joinedTeams: data.result}, () => {

                    if (this.props.value) {
                        let value = JSON.parse(this.props.value);

                        this.setState({activeTeam: this.getTeamById(value.team)}, () => {
                            this.updateChannelsByTeam(true).then(() => {
                                this.setState({activeChannel: this.getChannelById(value.channel)});
                            });
                        });

                    } else {
                        this.setState({showLoader: false});
                    }
                });
            });
    }

    getChannelById(id: string): Channel | null {
        let channelFound = null;
        this.state.teamChannels.map((channel: Channel) => {
            if (channel.id == id) {
                channelFound = channel;
            }
        });
        return channelFound;
    }

    getTeamById(id: string): Team | null {
        let teamFound = null;
        this.state.joinedTeams.map((team: Team) => {
            if (team.id == id) {
                teamFound = team;
            }
        });
        return teamFound;
    }

    updateChannelsByTeam(firstCall?: boolean) {
        return new Promise<any>((resolve, reject) => {
            if (this.state.activeTeam) {
                this.setState({showLoader: true}, () => {
                    fetch('/wp-json/erl-api/v1/teams/get-channels-by-team', {
                        method: 'POST',
                        body: JSON.stringify({team: this.state.activeTeam.id}),
                        headers: this.apiHeaders,
                    })
                        .then(res => res.json())
                        .then((data) => {
                            this.setState({teamChannels: data.result, showLoader: false}, () => {
                                let channel = this.state.teamChannels[0]
                                if (firstCall && this.props.value) {
                                    let channelId = JSON.parse(this.props.value).channel;
                                    channel = this.state.teamChannels.filter(value => {
                                        return value.id === channelId;
                                    })[0];
                                }
                                this.setState({activeChannel: channel}, () => {
                                    this.updateValue().then(() => resolve());
                                });
                            });
                        })
                        .catch((error) => {
                            console.log(error);
                            reject();
                        });
                });
            } else {
                this.setState({teamChannels: []}, () => {
                    resolve();
                });
            }
        });
    }

    setState(state: any, callback?: () => void) {
        super.setState(state, callback);
    }

    updateValue() {
        return new Promise<any>((resolve, reject) => {
            if (this.state.activeTeam && this.state.activeChannel) {
                this.setState({
                    value: JSON.stringify({
                        team: this.state.activeTeam.id,
                        channel: this.state.activeChannel.id,
                    })
                }, () => resolve());
            } else {
                this.setState({
                    value: '',
                }, () => resolve());
            }
        });
    }

    render() {
        return <div className="incoming-leads">
            <input type="hidden" value={this.state.value} name={this.props.name} id={this.props.name}/>
            <div className="label">{this.props.label}</div>

            {this.state.showLoader &&
            <LoaderSpinner/>
            }

            {!this.state.showLoader &&
            <div>
                <select value={this.state.activeTeam ? this.state.activeTeam.id : 0} onChange={(event) => {
                    this.setState({activeTeam: this.getTeamById(event.target.value), activeChannel: null}, () => {
                        this.updateValue();
                        this.updateChannelsByTeam();
                    });
                }}>
                    <option key={0} value={0}>-- Kein Team gewählt --</option>
                    {this.state.joinedTeams.map((team: Team) => {
                        return <option key={team.id} value={team.id}>{team.properties.displayName}</option>
                    })}
                </select>

                {this.state.activeTeam &&
                <select value={this.state.activeChannel ? this.state.activeChannel.id : 0} onChange={(event) => {
                    this.setState({activeChannel: this.getChannelById(event.target.value)}, () => {
                        this.updateValue();
                    });
                }}>
                    {this.state.teamChannels.map((channel: Channel) => {
                        return <option key={channel.id} value={channel.id}>{channel.properties.displayName}</option>
                    })}
                </select>
                }
            </div>
            }
        </div>
    }
}
